import NcrNoteCard from "../../../../../../../components/app-specific/ncr-cards/ncr-note-card";
import InfiniteScroll from "react-infinite-scroller";
import React from "react";
import {Paper, Skeleton, Typography} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";


const NoteGridView = ({notes, updateNote, removeNote, loadMoreData, hasMoreNotesToLoad, searchData}) => {

    return (
        <>
            <Paper elevation={0} sx={{padding: 2, margin: 0, borderRadius: 1}}>
                <InfiniteScroll
                    pageStart={0}
                    loadMore={loadMoreData}
                    hasMore={hasMoreNotesToLoad}
                    useWindow={false}
                    getScrollParent={() => document.querySelector('main')}
                    threshold={400}
                >
                    <Grid container spacing={2} margin={0}>
                        {
                            notes?.map((note) => (
                                <Grid className={'grid-view-note-card'} key={note?.id} xs={12} md={6} lg={4} xl={3}>
                                    <NcrNoteCard
                                        isNotesPage={true}
                                        note={note}
                                        update={updateNote}
                                        remove={removeNote}
                                    />
                                </Grid>
                            ))
                        }
                    </Grid>
                </InfiniteScroll>
                {
                    searchData?.loading &&
                    <Grid container spacing={2} margin={0}>
                        {
                            Array.from({length: 8}).map((e, index) =>
                                <Grid key={index} xs={12} md={6} lg={4} xl={3}>
                                    <Skeleton height={350} sx={{transform: 'none'}}/>
                                </Grid>
                            )
                        }
                    </Grid>
                }
                {
                    !searchData?.loading && notes?.length < 1 &&
                    <Grid container spacing={2} margin={0}>
                        <Grid xs={12}>
                            <Typography variant={'body2'} marginBlock={6} width={'100%'} textAlign={'center'}>
                                There are no NCR notes to show at the moment.
                            </Typography>
                        </Grid>
                    </Grid>
                }
            </Paper>
        </>
    )
};

export default NoteGridView;
